<div class="headerDs__bg headerDs__bg--{{type}}" [class.transparent]="isTransparent">
  <div class="headerDs__cont headerDs__cont--{{type}}">
    <ng-container *ngIf="logoIsEnabled">
      <div class="headerDs__cont__logo" (click)="clickAction.emit()">
        <app-ds-image
          [src]="logo"
          [alt]="logoSize"
          [size]="logoSize"
          [width]="'100px'"
          [height]="'40px'">
        </app-ds-image>
      </div>
    </ng-container>
    <div class="headerDs__cont__widgets headerDs__cont__widgets--{{type}}">
      <ng-container *ngFor="let widget of widgetsByConfig; trackBy: trackById; last as isLast; first as isFirst">
        <ng-container *ngIf="getHeaderWidgetComponentType(widget) as headerWidgetComponentType">
          <div class="headerDs__cont__widgets__widget headerDs__cont__widgets__widget--{{type}} {{widget.Type}} {{headerWidgetComponentType}}">
            <ng-container [ngSwitch]="headerWidgetComponentType">
              <ng-container *ngSwitchCase="widgetComponentTypes.SearchDataInfo">
                <ng-container *ngTemplateOutlet="searchDataInfoWidget; context: { widget: widget }"></ng-container>
              </ng-container>
              <ng-container *ngSwitchCase="widgetComponentTypes.ReservationDataInfo">
                <ng-container *ngTemplateOutlet="reservationDataInfoWidget; context: { widget: widget }"></ng-container>
              </ng-container>
              <ng-container *ngSwitchCase="widgetComponentTypes.InputSearch">
                <ng-container *ngTemplateOutlet="inputSearchWidget; context: { widget: widget }"></ng-container>
              </ng-container>
              <ng-container *ngSwitchCase="widgetComponentTypes.Label">
                <ng-container *ngTemplateOutlet="labelWidget; context: { widget: widget, isLast: isLast }"></ng-container>
              </ng-container>
              <ng-container *ngSwitchCase="widgetComponentTypes.Title">
                <ng-container *ngTemplateOutlet="titleWidget; context: { widget: widget, isFirst: isFirst }"></ng-container>
              </ng-container>
              <ng-container *ngSwitchCase="widgetComponentTypes.Card">
                <ng-container *ngTemplateOutlet="cardWidget; context: { widget: widget }"></ng-container>
              </ng-container>
              <ng-container *ngSwitchCase="widgetComponentTypes.ButtonFloating">
                <ng-container *ngTemplateOutlet="buttonFloatingWidget; context: { widget: widget }"></ng-container>
              </ng-container>
              <ng-container *ngSwitchCase="widgetComponentTypes.Tab">
                <ng-container *ngTemplateOutlet="tabWidget; context: { widget: widget }"></ng-container>
              </ng-container>
              <ng-container *ngSwitchCase="widgetComponentTypes.ButtonIcon">
                <ng-container *ngTemplateOutlet="buttonIconWidget; context: { widget: widget }"></ng-container>
              </ng-container>
            </ng-container>
          </div>
        </ng-container>
      </ng-container>
    </div>
  </div>
  <div class="headerDs__divider headerDs__divider--{{type}}">
    <app-ds-divider></app-ds-divider>
  </div>
  <div class="headerDs__loader-bar headerDs__loader-bar--{{type}}">
    <ngx-loading-bar
      [includeSpinner]="false"
      [color]="loaderBarColor"
      [fixed]="false">
    </ngx-loading-bar>
  </div>
</div>

<ng-template #buttonFloatingWidget let-widget="widget">
  <div class="headerDs__cont__widgets__widget headerDs__cont__widgets__widget--floating {{widget.Type}}">
    <app-ds-button-floating
      [icon]="widgetIcon(widget)"
      [label]="widgetLabel(widget, widgetComponentTypes.ButtonFloating)"
      (clickEvent)="clickAction.emit(widget)">
    </app-ds-button-floating>
  </div>
</ng-template>

<ng-template #buttonIconWidget let-widget="widget">
  <ng-container *ngIf="widgetIcon(widget)">
    <app-ds-button-icon
      [icon]="widgetIcon(widget)"
      [labelSize]="fontSize.XXXS"
      [labelFontFamily]="fontFamily.SemiBold"
      [label]="widgetLabel(widget, widgetComponentTypes.ButtonIcon)"
      [buttonSize]="buttonIconSize"
      [isLoading]="widgetLoading(widget)"
      [iconSize]="widgetIconSize(widget)"
      (clickEvent)="clickAction.emit(widget)">
    </app-ds-button-icon>
  </ng-container>
</ng-template>

<ng-template #reservationDataInfoWidget let-widget="widget">
  <ng-container *ngIf="widgetReservationDataInfo(widget) as reservationDataInfo">
    <div class="headerDs__cont__widgets__widget headerDs__cont__widgets__widget--reservation-data-info {{widget.Type}}">
      <div class="headerDs__cont__widgets__widget headerDs__cont__widgets__widget--reservation-data-info__cont">
        <app-ds-typography
          [fontFamily]="fontFamily.SemiBold"
          [size]="fontSize.XXS"
          [color]="widgetLabelColor(widget)"
          [ellipsis]="true"
          [text]="reservationDataInfo.Title">
        </app-ds-typography>
        <ng-container *ngIf="reservationDataInfo?.Subtitle">
          <app-ds-typography
            [size]="fontSize.XXXS"
            [color]="widgetLabelColor(widget)"
            [text]="reservationDataInfo.Subtitle">
          </app-ds-typography>
        </ng-container>
      </div>
    </div>
  </ng-container>
</ng-template>

<ng-template #searchDataInfoWidget let-widget="widget">
  <ng-container *ngIf="widgetSearchDataInfo(widget) as searchDataInfo">
    <div class="headerDs__cont__widgets__widget headerDs__cont__widgets__widget--search-data-info {{widget.Type}}" (click)="editEventBySearchData()">
      <div class="headerDs__cont__widgets__widget--search-data-info__titles">
        <ng-container *ngFor="let title of searchDataInfo.Titles; trackBy: trackById">
          <ng-container *ngIf="title?.Icon">
            <app-ds-icon
              class="headerDs__cont__widgets__widget--search-data-info__titles__icon"
              [size]="widgetIconSize(widget)"
              [icon]="title.Icon"
              [color]="widgetIconColor(widget)">
            </app-ds-icon>
          </ng-container>
          <ng-container *ngIf="title?.Text">
            <app-ds-typography
              [fontFamily]="fontFamily.SemiBold"
              [size]="fontSize.XXS"
              [color]="widgetLabelColor(widget)"
              [ellipsis]="true"
              [text]="title.Text">
            </app-ds-typography>
          </ng-container>
        </ng-container>
      </div>
      <div class="headerDs__cont__widgets__widget--search-data-info__info">
        <div class="headerDs__cont__widgets__widget--search-data-info__info__dates">
          <app-ds-typography
            [size]="fontSize.XXXS"
            [color]="widgetLabelColor(widget)"
            [text]="searchDataInfo.Dates">
          </app-ds-typography>
        </div>
        <ng-container *ngIf="searchDataInfo?.Subtitles?.length">
          <div class="headerDs__cont__widgets__widget--search-data-info__info__subtitles">
            <ng-container *ngFor="let subtitle of searchDataInfo.Subtitles; trackBy: trackById">
              <div class="headerDs__cont__widgets__widget--search-data-info__info__subtitles__subtitle">
                <ng-container *ngIf="subtitle?.Icon">
                  <app-ds-icon
                    class="headerDs__cont__widgets__widget--search-data-info__info__subtitles__subtitle__icon"
                    [size]="widgetIconSize(widget, subtitle.Icon)"
                    [icon]="subtitle.Icon"
                    [color]="widgetIconColor(widget)">
                  </app-ds-icon>
                </ng-container>
                <ng-container *ngIf="subtitle?.Text">
                  <app-ds-typography
                    [size]="fontSize.XXXS"
                    [color]="widgetLabelColor(widget)"
                    [text]="subtitle.Text">
                  </app-ds-typography>
                </ng-container>
              </div>
            </ng-container>
          </div>
        </ng-container>
      </div>
    </div>
  </ng-container>
</ng-template>

<ng-template #labelWidget let-widget="widget" let-isLast="isLast">
  <div class="headerDs__cont__widgets__widget headerDs__cont__widgets__widget--label {{widget.Type}}" [class.last]="isLast">
    <app-ds-typography
      class="headerDs__cont__widgets__widget headerDs__cont__widgets__widget--label__action"
      [fontFamily]="fontFamily.SemiBold"
      [size]="fontSize.XXS"
      [color]="widgetLabelColor(widget)"
      [text]="widgetLabel(widget, widgetComponentTypes.Label)"
      (click)="clickAction.emit(widget)">
    </app-ds-typography>
  </div>
</ng-template>

<ng-template #titleWidget let-widget="widget" let-isFirst="isFirst">
  <div class="headerDs__cont__widgets__widget headerDs__cont__widgets__widget--title headerDs__cont__widgets__widget--title-{{widgetLabelAlign(widget)}} {{widget.Type}}" [class.first]="isFirst">
    <ng-container *ngIf="widgetLabelIcon(widget) as icon">
      <app-ds-icon
        class="headerDs__icon-title"
        [size]="20"
        [color]="iconFillHighlight"
        [icon]="icon">
      </app-ds-icon>
    </ng-container>
    <app-ds-typography
      [fontFamily]="fontFamily.SemiBold"
      [size]="fontSize.SM"
      [color]="widgetLabelColor(widget)"
      [ellipsis]="true"
      [text]="widgetLabel(widget, widgetComponentTypes.Label)">
    </app-ds-typography>
  </div>
</ng-template>

<ng-template #inputSearchWidget let-widget="widget">
  <div class="headerDs__cont__widgets__widget headerDs__cont__widgets__widget--input-search {{widget.Type}}">
    <app-ds-input-search
      [isReadonly]="true"
      [size]="inputSearchSize"
      [placeholder]="widgetLabel(widget, widgetComponentTypes.InputSearch)"
      (click)="clickAction.emit(widget)">
    </app-ds-input-search>
  </div>
</ng-template>

<ng-template #tabWidget let-widget="widget">
  <div
    class="headerDs__cont__widgets__widget headerDs__cont__widgets__widget--tab {{widget.Type}}"
    [class.activated]="widgetIsActivated(widget)"
    (click)="clickAction.emit(widget)">
    <ng-container *ngTemplateOutlet="widgetLink(widget) ? tabWidgetLink : tabWidgetDiv; context: { widget: widget }"></ng-container>
  </div>
</ng-template>

<ng-template #tabWidgetLink let-widget="widget">
  <a
    class="headerDs__cont__widgets__widget headerDs__cont__widgets__widget--tab {{widget.Type}}" target="_blank" rel="noopener"
    [href]="widgetLink(widget)">
    <ng-container *ngTemplateOutlet="tabWidgetContent; context: { widget: widget }"></ng-container>
  </a>
</ng-template>

<ng-template #tabWidgetDiv let-widget="widget">
  <div
    class="headerDs__cont__widgets__widget headerDs__cont__widgets__widget--tab {{widget.Type}}"
    [class.activated]="widgetIsActivated(widget)">
    <ng-container *ngTemplateOutlet="tabWidgetContent; context: { widget: widget }"></ng-container>
  </div>
</ng-template>

<ng-template #tabWidgetContent let-widget="widget">
  <div class="headerDs__cont__widgets__widget--divider-full" *ngIf="widgetTabLeftDividerIsEnabled(widget)">
    <app-ds-divider
      [orientation]="dividerOrientation">
    </app-ds-divider>
  </div>
    <div class="headerDs__cont__widgets__widget--tab__cont {{widget.Type}}">
      <div class="headerDs__cont__widgets__widget--tab__cont__icon" *ngIf="widgetIcon(widget)">
        <app-ds-icon
          [size]="widgetIconSize(widget)"
          [icon]="widgetIcon(widget)"
          [color]="widgetIconColor(widget)">
        </app-ds-icon>
      </div>
      <div class="headerDs__cont__widgets__widget--tab__cont__text" *ngIf="widgetTabLabelIsEnabled(widget)">
        <app-ds-typography
          [fontFamily]="fontFamily.SemiBold"
          [size]="fontSize.XXS"
          [color]="widgetLabelColor(widget)"
          [text]="widgetLabel(widget, widgetComponentTypes.Tab)">
        </app-ds-typography>
      </div>
    </div>
    <div class="headerDs__cont__widgets__widget--divider-default" *ngIf="widgetTabRightDividerIsEnabled(widget)">
      <app-ds-divider
        [orientation]="dividerOrientation">
      </app-ds-divider>
    </div>
</ng-template>

<ng-template #cardWidget let-widget="widget">
  <div class="headerDs__cont__widgets__widget headerDs__cont__widgets__widget--{{widget.Type}}">
    <div class="headerDs__cont__widgets__widget--{{widget.Type}}__cont__icon" *ngIf="widgetIcon(widget)">
      <app-ds-icon
        [size]="widgetIconSize(widget)"
        [icon]="widgetIcon(widget)"
        [color]="widgetIconColor(widget)">
      </app-ds-icon>
    </div>
    <div class="headerDs__cont__widgets__widget--{{widget.Type}}__cont__text">
      <app-ds-typography
        [fontFamily]="fontFamily.SemiBold"
        [size]="fontSize.XXS"
        [color]="widgetLabelColor(widget)"
        [text]="widgetLabel(widget, widgetComponentTypes.Card)">
      </app-ds-typography>
    </div>
    <div class="headerDs__cont__widgets__widget--{{widget.Type}}__cont__image" *ngIf="widgetLogo(widget) as widgetLogo">
      <app-ds-image
        [src]="widgetLogo"
        [alt]="logoSize"
        [size]="logoSize"
        [width]="'100px'"
        [height]="'12px'">
      </app-ds-image>
    </div>
  </div>
</ng-template>